import { lazy } from 'react';
export var LessonPageAsync = lazy(function () { return import('./LessonPage'); });
